import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Route } from 'react-router-dom';
import SecureRoute from 'routes/SecureRoute';

@observer
class RouteWithLayout extends Component {
  render() {
    const WrappingRoute = this.props.secure ? SecureRoute : Route;
    const Layout = require(`containers/layouts/${this.props.layout || 'MainLayout'}`).default;
    const NavigationPage = this.props.navigationPage;

    return (
      <WrappingRoute
        area={this.props.area || 'public'}
        exact={this.props.exact}
        path={this.props.path}
        component={(props) => (
          <Layout pageId={this.props.pageId}>
            <NavigationPage {...props} />
          </Layout>
        )}
      />
    );
  }
}

export default RouteWithLayout;



// WEBPACK FOOTER //
// ./src/routes/RouteWithLayout.jsx